"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.MenuItem = {
  name: 'MenuItem',
  autoRoutes: ['list', 'create', 'update'],
  useCreator: true,
  list: {
    resultsVariant: "table"
  },
  table: {
    fieldNames: ["info", "page", "path"],
    options: {
      info: {
        weight: 1
      },
      path: {
        weight: 3
      }
    }
  },
  form: {
    modal: {
      maxWidth: "1000px"
    },
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      page: {
        type: 'linked',
        entityTypeName: 'Page',
        description: 'Select the {{PAGE}} this menu item links to'
      },
      path: {
        type: 'text',
        recommended: false,
        updateArgs: "auto: false",
        description: 'OR Specify a custom path in the site or a full URL to link to'
      },
      children: {
        type: 'linkedMultiple',
        recommended: false,
        label: "Children",
        entityTypeName: 'MenuItem',
        description: 'Does this {{MENU_ITEM}} have any child items?'
      }
    })
  }
};